<template>
  <div style="min-height: 240px;">
    <div class="chart-title">Last 7 Active Days</div>
    <div class="settings-button">
      <miniSettings />
    </div>
    <apexchart
      class="mb-6"
      v-if="data"
      type="bar"
      height="200"
      ref="sevenuser"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="width-full float-left text-center text-grey no-trades" v-else>NO TRADES</div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
import miniSettings from "./miniSettings";
export default {
  name: "MiniSeven",
  components: { miniSettings },
  props: ["data", "inverse"],
  data() {
    return {
      labels: [],
      values: [],
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      chartOptions: {
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top"
            },
            columnWidth: "95%",
            distributed: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 999999,
                  color: "#79C04D"
                },
                {
                  from: -999999,
                  to: -1,
                  color: "#E62163"
                }
              ]
            }
          }
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              colors: "#808F9C",
              fontSize: "12px",
              fontFamily: "Roboto Condensed, sans-serif",
              fontWeight: "bold"
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false
        },
        labels: [],
        dataLabels: {
          offsetY: -20,
          enabled: true,
          formatter: function(val) {
            if (val != 0) return "$ " + val.toFixed(0);
          }
        },
        colors: [],
        chart: {
          events: {
            dataPointSelection: (event, chartContext, config) => {
              var index = config.selectedDataPoints[0];
              this.routeToDiary(index);
            }
            /*
            dataPointSelection: function(event, chartContext, config) {
              var index = config.selectedDataPoints[0];
              this.routeToDiary(index); // <-- can't call this.functionA()
            }
            */
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          show: false,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0
        }
      },
      series: [{data: [] }]
    };
  },
  methods: {
    routeToDiary(data) {
      //alert(this.data[data].pl)
      
      if(this.$route.params.name)
      return this.$router.push({ path: "/journal/" + this.$route.params.name +"/"+ this.data[data].date});
      else
      return this.$router.push({ path: "/journal/" + this.$store.getters.username +"/"+ this.data[data].date});
    },
    newData() {
      /*
      this.data.forEach(day => {
        this.labels.push(day.createdAt);
        this.values.push(day.pl);
      });

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          labels: this.labels
        }
      };
      this.$refs.sevenuser.updateSeries([
        {
          data: this.values
        }
      ]);
      */
      this.values = [];
      this.labels = [];

      if (this.inverse) {
        this.data.forEach(dRes => {
          this.values.unshift(dRes.pl);
          this.labels.unshift(moment(dRes.createdAt).format("MM/DD"));
        });
      } else {
        this.data.forEach(dRes => {
          this.values.push(dRes.pl);
          this.labels.push(moment(dRes.createdAt).format("MM/DD"));
        });
      }

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          labels: this.labels
        }
      };
      this.$refs.sevenuser.updateSeries(
        [
          {
            data: this.values
          }
        ],
        true,
        true
      );

      this.$refs.sevenuser.updateOptions(
        [
          {
            data: this.values
          }
        ],
        true,
        true
      );
    }
  },
  mounted() {
    this.newData();
  },
  watch: {
    data() {
      this.newData();
    }
  }
};
</script>

<style>
</style>